export enum EventTaskTypes {
    Dispatch = 4,
}